import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import './invoiceData.css';
import _isEmpty from 'lodash/isEmpty';
import { getFbiRebate,tabTracking} from '../../../actions';
import _get from 'lodash/get';
import _find from 'lodash/find';
// import { Dropdown } from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { PriceFormatter, dynamicDateFilters, monthName,PercentFormatter,jsonToParam,paramsToJSON } from '../../../helper';
import { matLoader } from '../../../components/Loader';

class FBIRebate extends React.Component {
    state = {
        isLoading: true,
        params: {
        //   year : 2021,
        //   year : 2023,
        year : 2024,
        },
    }

    componentWillMount() {
        
        let params = this.state.params;
        //let paramsfinal = dynamicDateFilters(paramsValues);
     params = jsonToParam(params);

        console.log(params);
        this.setState({ params: params });
        //;
       // params = paramsToJSON(params);
        
    }

    componentDidMount() {
        Promise.all([
             this.props.getFbiRebateAPI(this.state.params),
             this.props.tabTrackingAPI("tabId=8"),
            // this.props.getMemberVendorNamesAPI(this.state.params)
        ]).then(data=>{
            this.setState({
                isLoading: false
            })
        }).catch(err=>{
            this.setState({
                isLoading: false
            })
        }) 
       
    }
    handleChangeOfDropdown(event){
        let obj = {};
        obj[event.name] = event.value;
        this.setState(obj,()=>{
            this.setFilter({year:this.state.year});
        });
    }
    setFilter = (filter) => {
        console.log(filter);
        let params = this.state.params;
        params = paramsToJSON(params);
        params.year = filter.year;
        params = jsonToParam(params);
        this.setState({
            params: params,
            refreshData: true,
            isLoading: true
        }, () => Promise.all([
            this.props.getFbiRebateAPI(this.state.params),
        ]).then(data => {

            this.setState({
                isLoading: false
            })
        }).catch(err => {

            this.setState({
                isLoading: false
            })
        }))

    }

    showDate = (row) =>{
        let date = new Date(row);
        return (
        <div>{date.toLocaleDateString()}</div>
        )
      }
    
    render() {
        const { getInvoiceData } = this.props;
        let todayDate = new Date();
        let dateForMaxStart = todayDate.toISOString().split('T')[0];
        return (
            <div className ="Dashboard">
                <nav className="Filters navbar">
                    <span className="navbar-brand nav-head">Supplier FBI Programs</span>
                    <div> 
                    <div className="clearAllWrapper" style ={{marginLeft:"280px"}}> 
                    <li className="nav-item" style= {{listStyle: "none"}}>
                    <select className="form-control" style ={{ height :'38px' }} onChange={(e)=>{this.handleChangeOfDropdown({name:"year",value:e.target.value})}}>
                    {/* <option value="2021" selected >2021</option>
                                <option value="2020">2020</option>
                                <option value="2019">2019</option>
                                <option value="2018">2018</option>
                                <option value="2017">2017</option> */}
                                 <option value="2024" selected >2024</option>
                                 <option value="2023" >2023</option>
                                 <option value="2022">2022</option>
                                <option value="2021">2021</option>
                                <option value="2020">2020</option>
                                <option value="2019">2019</option>
                                <option value="2018">2018</option>
                                <option value="2017">2017</option>
                            </select>
                   </li>
        </div>

            </div>
            
                </nav>
                {this.state.isLoading ? matLoader() : <div>
                
                <div className="row" style={{ paddingBottom: "12px", paddingTop: "", marginLeft: "", marginTop: "" }}>
                    <div style={{ marginTop:"10px" }} className="col-12"> 
                 
                        <div className="card-deck">
                    <div className="card shadow-sm mb-3">

                        {/* <div className="card-header">Supplier FBI Programs</div> */}
                        
                        <div className="card-body" style={{ maxHeight: "400" }}>
                        <h5 style={{textDecorationLine: 'underline',marginBottom:'-20px'}}>Supplier FBI Programs</h5>
                        <BootstrapTable height='400' search data={this.props.getFbiRebate} striped hover version="4">
                            <TableHeaderColumn tdStyle={ { whiteSpace: 'normal' } } width ={160} dataSort={ true } isKey dataField='vendorName'>Supplier Name</TableHeaderColumn>
                            <TableHeaderColumn thStyle={ { whiteSpace: 'normal' } } tdStyle={ { whiteSpace: 'normal' } } dataSort={ true } width ={170} dataFormat={PercentFormatter} dataField='rebatePercentImarkLlc'>Rebate % IMARK LLC</TableHeaderColumn>
                            <TableHeaderColumn thStyle={ { whiteSpace: 'normal' } } tdStyle={ { whiteSpace: 'normal' } } dataSort={ true } width ={220} dataFormat={PercentFormatter} dataField='rebatePercentImarkPlumbing'>Rebate % IMARK Plumbing</TableHeaderColumn>
                            <TableHeaderColumn tdStyle={ { whiteSpace: 'normal' } } dataSort={ true } width ={200} dataField='terms'>Terms</TableHeaderColumn>
                            <TableHeaderColumn tdStyle={ { whiteSpace: 'normal' } } dataSort={ true } width ={400} dataField='exclusions'>Exclusions</TableHeaderColumn>
                        </BootstrapTable>
                        </div>
                        </div></div>
                    </div>
                </div>
            </div>}
            </div>
        )
    }
}

function mapStateToProps(state) {

    return {
        getFbiRebate: _get(state, 'corporate.getFbiRebate', []),
        tabTracking: _get(state, 'corporate.tabTracking', []),

    }

}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
         getFbiRebateAPI: getFbiRebate,
         tabTrackingAPI:tabTracking,
    },
        dispatch)
}
export default connect(mapStateToProps, mapDispatchToProps)(FBIRebate);